<script>
import { fade } from 'svelte/transition';
import Centering from "../layouts/Centering.svelte";
import { API_URL } from "../constants/api"
import LinkList from "../components/LinkList.svelte";
import FillButton from "../components/FillButton.svelte"
import FloatingContent from "../components/FloatingContent.svelte"
async function getNews() {
		const res = await fetch(`${API_URL}/data.json`);
		const data = await res.json();

		if (res.ok) {
			return data;
		} else {
			throw new Error(data);
		}
}
const promise = getNews()
</script>

<svelte:head>
	<title>株式会社有倉商店</title>
</svelte:head>
<div transition:fade>
  <div class="fv-wrapper">
    <picture class="fv">   
      <source srcset="img/home-fv.png" media="(min-width: 641px)" />
      <source srcset="img/home-fv_mb.png" media="(min-width: 0px)" >
      <img src="img/home-fv.png"  alt="">
  </picture> 
    <Centering>
      <div class="fv-msg">
        <p class="msg1">
          美味しい果物は、
          食べた人を「笑顔」にします。
        </p>
        <p class="msg2">
          美味しい野菜は、
          食べた人を「健康」にします。
        </p>
      </div>
    </Centering>
  </div>
  <!-- <div class="news">
    <Centering>
      <div class="news-wrapper">
        <h2>NEWS</h2>
        <div class="news-list">
          {#await promise then data}
            <LinkList list={data.news} />          
          {/await}
        </div>
        <FillButton 
          href="/news"
          style={{
              width:325,
              height:60,
              borderWidth:2,
              color:"#FF9B11",
              base:"#F5F5F5"
          }}
          text="ニュース一覧を見る"
        />
      </div>
    </Centering>
  </div> -->
  <div class="about">
      <div class="about-left">
        <img src="img/top-text.svg" alt="">
      </div>
      <div class="about-right">
        <div class="about-content">
          <h3>
            ＨＡＣＣＰの
            考え方を
            取り入れた衛生管理
          </h3>
          <p>
            わたくしたち株式会社有倉商店は、お客様の口に入る商材を取り扱っていますので、 私たちがこだわり厳選した野菜と果物で、「笑顔」と「健康」をお届けする事が私たちの使命と考えます。  
          </p>
          <FillButton 
          href="/company/about"
          style={{
              width:325,
              height:60,
              borderWidth:2,
              color:"#FF9B11",
              base:"#FFF"
          }}
          text="会社方針を詳しくを見る"
        />
        </div>
      </div>
  </div>
  <div class="intro">
    <Centering>
      <div class="intro-inner">
        <FloatingContent style={{width:"1124px",height:"531px",mbWidth:"100%",mbHeight:"auto"}}>
          <div class="inner reverse">
            <div class="txt">
              <h2>PRODUCTS</h2>
              <h3>有倉で扱っている
                野菜・果物・
                下処理（カット）商品</h3>
              <p>有倉では国内外の野菜・果物を仕入れ、一つ一つ選果しお届けしています。選果されたそのままの商品形態だけではなく、下処理（カット）加工を施した野菜商品にも力を入れています。</p>
              <div class="btn">
                <FillButton 
                href="/product"
                style={{
                    width:325,
                    height:60,
                    borderWidth:2,
                    color:"#FF9B11",
                    base:"#FFF"
                }}
                text="商品について詳しく見る"
              />
              </div>
            </div>
            <picture>   
              <source srcset="img/product-thum.png" media="(min-width: 641px)" />
              <source srcset="img/product-thum.png" media="(min-width: 0px)" >
              <img src="img/product-thum.png" alt="">
            </picture>
          </div>
        </FloatingContent>
        <FloatingContent style={{width:"1124px",height:"531px",mbWidth:"100%",mbHeight:"auto"}}>
          <div class="inner">
            <picture>   
              <source srcset="img/home-01.png" media="(min-width: 641px)" />
              <source srcset="img/home-01_mb.png" media="(min-width: 0px)" >
              <img src="img/home-01.png" alt="">
            </picture>
            <div class="txt">
              <h2>SERVICE</h2>
              <h3>青果と、
                下処理野菜、
                有倉が取り組む強化5項目</h3>
              <p>弊社を代表する仕入れスタッフの高品質な仕入力と、「汚れ」「傷み」が無いか、一つずつ手作業でのチェックを行う選果力、有倉の提供サービスをご紹介致します。</p>
              <div class="btn">
                <FillButton 
                href="/service"
                style={{
                    width:325,
                    height:60,
                    borderWidth:2,
                    color:"#FF9B11",
                    base:"#FFF"
                }}
                text="事業内容を詳しくを見る"
              />
              </div>
            </div>
          </div>
        </FloatingContent>
        <FloatingContent style={{width:"1124px",height:"531px",mbWidth:"100%",mbHeight:"auto"}}>
            <div class="inner reverse">
              <div class="txt">
                <h2>COMPANY</h2>
                <h3>有倉の歴史
                  これまでの取り組みや
                  拠点のご紹介</h3>
                <p>未来ある子供たちに、笑顔あふれる美味しい野菜と果物を！
                  入院されている患者様に、滋味溢れる新鮮な野菜と果物を！
                  有倉の企業情報をご案内致します。</p>
                <div class="btn">
                  <FillButton 
                  href="/company/info"
                  style={{
                      width:325,
                      height:60,
                      borderWidth:2,
                      color:"#FF9B11",
                      base:"#FFF"
                  }}
                  text="会社情報を詳しくを見る"
                />
                </div>
              </div>
              <picture>   
                <source srcset="img/home-02.png" media="(min-width: 641px)" />
                <source srcset="img/home-02_mb.png" media="(min-width: 0px)" >
                <img src="img/home-02.png" alt="">
              </picture>
            </div>
        </FloatingContent>
      </div>
    </Centering>
  </div>
</div>

<style>
  .fv-wrapper{
    padding-bottom: 592px;
  }
    .fv{
      position: absolute;
        display: flex;
        width:100%;
        min-width:1280px;
        height:592px;
        height:auto;
    }
    .fv img{
        width:100%;
        height:592px;
        object-fit: cover;
    }
    .fv-msg{
      position: absolute;
      z-index: 10;
      width: 100%;
      top: 210px;
      display: block;
      border-right: 2px solid #fff;
      border-bottom: 2px solid #fff;
      width: 1064px;
      height: 309px;
    }
    .fv-msg p{
      font-family: "Noto Sans JP",sans-serif;
      -webkit-font-smoothing: antialiased;
      font-weight: normal;
      font-size: 24px;
      line-height: 35px;
      height: 35px;
      text-align: left;
      color: #000;
      background-color: #fff;
      display: block;
      width: 531px;
      padding-left: 8px;
      position: relative;
      margin: 0;
    }
    .fv-msg .msg1{
      margin-top: 200px;
    }
    .fv-msg .msg2{
      margin-top: 10px;
    }
    .news{
      margin-top: 42px;
    }
    .news h2{
      font-family: "Noto Sans JP",sans-serif;
      -webkit-font-smoothing: antialiased;
      font-weight: normal;
      font-size: 60px;
      line-height: 36px;
      text-align: left;
      color: #000;
    }
    .news-wrapper{
      display: flex;
      flex-direction: column;
    }
    .news-list{
      margin-bottom: 42px;
    }
    .about{
      margin-top: 0px;
      width: 1280px;
      margin: auto;
      height:562px;
      display: flex;
    }
    .about-left{
      min-width:580px;
      width:45%;
      background-color: #D5BC99;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    }
    .about-right{
      width:55%;
      min-width: 700px;
      background-color: #fff;
    }
    .about-content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: auto;
      width: 580px;
      height: 562px;
      background: #fff;
    }
    .about h3{
      margin: 0px;
      margin-top: 34px;
      font-family: "Noto Sans JP",sans-serif;
      -webkit-font-smoothing: antialiased;
      font-weight: normal;
      font-size: 24px;
      text-align: left;
      color: #000;
      white-space: pre-line;
    }
    .about p{
      width: 383px;
      height: 132px;
      font-family: "Noto Sans JP",sans-serif;
      -webkit-font-smoothing: antialiased;
      font-size: 16px;
      line-height: 36px;
      text-align: left;
      color: #000;
      margin: 0;
      margin-top: 30px;
      margin-bottom:30px;
    }
    .about-inner{
      display: flex;
      flex-direction: column;
    }
    .intro{
      display: flex;
      flex-direction: column;
      margin-top: 120px;
    }
    .intro-inner{
      display: flex;
      flex-direction: column;
      height: auto;
      justify-content: space-between;
      margin-bottom: 125px;
      gap: 60px;
    }
    .intro .inner{
      display: flex;
      width: 100%;
    }
    .intro .txt{
      width:470px;
      margin-left: 84px;
      margin-right:50px;
    }
    .intro h2{
      font-family: "Noto Sans JP",sans-serif;
      -webkit-font-smoothing: antialiased;
      font-weight: normal;
      font-size: 40px;
      line-height: 36px;
      text-align: left;
      color: #ff9b11;
      margin: 0;
      margin-top: 25px;
    }
    .intro h2:after{
        content:"";
        display: block;
        height:3px;
        width:46px;
        background-color: #FF9B11;
        margin-top: 10px;
    }
    .intro h3{
      font-family: "Noto Sans JP",sans-serif;
      -webkit-font-smoothing: antialiased;
      font-weight: normal;
      font-size: 24px;
      line-height: 41px;
      text-align: left;
      color: #000;
      white-space: pre-line;
      margin: 0;
      margin-top: 35px;
    }
    .intro p{
      font-family: "Noto Sans JP",sans-serif;
      -webkit-font-smoothing: antialiased;
      
      font-size: 16px;
      line-height: 36px;
      text-align: left;
      color: #000;
      width: 100%;
      margin: 0;
      margin-top: 35px;
    }
    .intro .btn{
      margin-top: 35px;
    }
    .intro img{
      justify-self: flex-end;
    }
    @media screen and (max-width:640px){
        .fv{
            min-width:100%;
            height:592px;
            width:100%;
        }
        .fv img{
            height:592px;
            width:100%;
            object-fit: cover;
        }
        .fv-msg{
          width: 144px;
          height:340px;
          right: 0px;
        }
        .fv-msg p{
          white-space: pre-line;
          position: absolute;
          right: 25px;
          height: 58px;
          font-size: 20px;
          text-align: left;
          line-height:29px;
          width:283px;
          display: inline-block;
        }
        .fv-msg .msg2{
          margin:0;
          bottom:25px;
        }
        .fv-msg .msg1{
          margin:0;
          bottom:110px;
        }
        .news-wrapper{
          width: 100%;
        }
        .news h2{
          font-size: 40px;
        }
        .about{
          width:100%;
          height:771px;
          flex-direction: column;
        }
        .about-left{
          min-width: 100%;
          height: 217px;
          width:100%;
        }
        .about-left img{
          width: 240px;
        }
        .about-right{
          min-width: 100%;
          width: 100%;
          height: 486px;
        }
        .about-content{
          width: calc(100% - 32px);
          height: 401px;  
          padding:0 16px;
          justify-content: space-between;
          margin-top: 35px;
          margin-bottom: 0;
        }
        .about h3{
          margin: 0px;
        }
        .about p{
          width: 100%;
          height: auto;
        }
        .about-inner{
          display: flex;
          flex-direction: column;
        }
      .intro-inner{
        display: flex;
        flex-direction: column;
        height:auto;
        justify-content: space-between;
        margin-bottom: 125px;
      }
      .intro{
        margin-bottom: 60px;
      }
      .intro .inner{
        flex-direction: column;
        padding-bottom: 50px;
      }
      .intro .txt{
        width:calc(100% - 32px);
        margin-left: 16px;
        margin-right:16px;
      }
    .intro h2{
      margin-top: 25px;
    }
    .intro h3{
      font-size: 16px;
      margin-top: 35px;
      line-height: 36px;
    }
    .intro p{
      width: 100%;
      margin-top: 25px;
      font-size: 14px;
    }
    .intro .btn{
      margin-top: 30px;
    }
    .intro img{
      width: 100%;
    }
    .intro .inner.reverse {
      flex-direction: column-reverse;
    }
    .intro{
      justify-content: space-between;
    }
    }
</style>